import styled from 'styled-components';
import Button from '../../components/Button/Button';
import { RouteComponentProps, useNavigate } from '@reach/router';
import { useTranslation } from 'react-i18next';

type IComponentProps = RouteComponentProps;

const NotFoundPage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const NotFoundContactSupport: React.FC<IComponentProps> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('general');
  return (
    <NotFoundPage>
      <p className="text-xl font-bold">{t('contactSupport')}</p>
      <Button color={'black-outline'} onClick={() => navigate('/')}>
        {t('backHome')}
      </Button>
    </NotFoundPage>
  );
};

export default NotFoundContactSupport;
